import {
  UploadLabel,
  UploadTypeDisplayPriority,
} from '@/context/services/invoice/type';
import { SelectProps } from '@moneyforward/ap-frontend-components';
import { useUploadTypesReceivedInvoicesSuspense } from 'ap-openapi';
import { useMemo } from 'react';

export const useReceivedInvoiceUploadTypeOptions =
  (): SelectProps['options'] => {
    const { data, error } = useUploadTypesReceivedInvoicesSuspense();

    if (error) throw error;

    const options = useMemo(() => {
      if (!data?.data?.upload_types) {
        return [];
      }

      const options = data.data.upload_types.map((uploadType) => ({
        value: uploadType,
        label: UploadLabel[uploadType] || '',
      }));

      return options.sort(
        (a, b) =>
          (UploadTypeDisplayPriority[a.value] ?? 0) -
          (UploadTypeDisplayPriority[b.value] ?? 0)
      );
    }, [data]);

    return options;
  };
